import { render, staticRenderFns } from "./GeneratedReportsPopUp.vue?vue&type=template&id=618b4114&scoped=true"
import script from "./GeneratedReportsPopUp.vue?vue&type=script&lang=js"
export * from "./GeneratedReportsPopUp.vue?vue&type=script&lang=js"
import style0 from "./GeneratedReportsPopUp.vue?vue&type=style&index=0&id=618b4114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618b4114",
  null
  
)

export default component.exports